<div class="occ-list">
    <div class="occ-item" *ngFor="let occ of items; trackBy: trackById" [class.is-open]="openId === occ.id">
        <button type="button" class="occ-head" (click)="toggle(occ.id)" [attr.aria-expanded]="openId === occ.id">
            <em class="fas fa-chevron-right occ-chevron"></em>
            <span class="occ-time">{{ toLocalDate(occ.createdDate) | date : 'dd/MM/yyyy HH:mm:ss' }}</span>
            <span class="window-type" *ngIf="occ.methodType">{{ occ.methodType }}</span>
            <span class="error-status-text occ-status {{ getStatus(occ.status).css }}">{{ getStatus(occ.status).text | translate }}</span>
        </button>
        <div class="occ-message">{{ occ.errorMessage }}</div>
        <div class="detail-block">
            <div class="detail-title" translate>lblRequest</div>
            <pre class="detail-pre" *ngIf="occ.paramDetails; else noRequest">{{ formatJson(occ.paramDetails) }}</pre>
            <ng-template #noRequest>
                <div class="occ-empty" translate>lblNoRequestDetails</div>
            </ng-template>
        </div>
        <ng-container *ngIf="openId === occ.id">
            <div class="detail-block" *ngIf="occ.innerException">
                <div class="detail-title" translate>lblInnerException</div>
                <pre class="detail-pre">{{ occ.innerException }}</pre>
            </div>
            <div class="detail-block" *ngIf="occ.stackTrace">
                <div class="detail-title" translate>lblStackTrace</div>
                <pre class="detail-pre">{{ occ.stackTrace }}</pre>
            </div>
        </ng-container>
    </div>

    <div class="occ-empty text-center" *ngIf="loading">
        <em class="fas fa-spinner fa-spin"></em>
    </div>
    <div class="occ-empty text-center" *ngIf="!loading && items.length === 0" translate>lblNoRecordsFound</div>
    <div class="text-center" *ngIf="!loading && items.length < totalCount">
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="loadMore.emit()">
            <span translate>lblShowMore</span> ({{ items.length }} / {{ totalCount }})
        </button>
    </div>
</div>
